export const GITHUB_KEY_PREFIX = "integrations.configuration.GitHub"
export const GITHUB_ISSUES_NOTIFICATIONS_KEY_PREFIX = `${GITHUB_KEY_PREFIX}.issues.notifications`
